import { ChakraProvider } from "@chakra-ui/react";
import React, { FC } from "react";

import Fonts from "./fonts";
import { Footer } from "../molecules/Footer/Footer";
import { Header } from "../molecules/Header/header";
import styled from "styled-components";
import theme from "../../theme/theme";

const Div = styled.div`
  animation: fadeInAnimation ease 0.8s;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;

  @keyframes fadeInAnimation {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;

const Layout = ({ children }: LayoutProps) => {
  return (
    <Div>
      <ChakraProvider theme={theme}>
        <Fonts />
        <Header />
        {children}
        <Footer />
      </ChakraProvider>
    </Div>
  );
};

type LayoutProps = {
  children: React.ReactNode;
};

export default Layout;
